export default {
    sections: {
        gps: {
            title: 'Managers database',
            description: '',
        },
        funds: {
            title: 'Funds database',
            description: '',
        },
        'funds-perf': {
            title: 'Funds perfomance',
            description: '',
        },
        trans: {
            title: 'Transactions database',
            description: '',
        },
        'trans-perf': {
            title: 'Investments performance',
            description: '',
        },
        companies: {
            title: 'Assets database',
            description: '',
        },
        'companies-evol': {
            title: 'Assets financial',
            description: '',
        },
        imports: {
            title: 'Imports',
            description: '',
        },
        schemaBuilder: {
            title: 'Schema builder',
            description: '',
        },
        users: {
            title: 'Users',
            description: '',
        },
    },
}
